import { createSearchSlice, searchInitialState } from '@sv-support-sdk/store';

const search = createSearchSlice({
  name: 'search',
  initialState: { ...searchInitialState },
  reducers: {},
});

export const searchActions = search.actions;

export default search.reducer;
